import { FixIntentController } from '../components/FixIntent/FixIntentController';
import FixIntentView from '../components/FixIntent/FixIntentView.html';
const ANALYSIS_DETAILS_ID = 'right-sidebar';
const CONTROLLER_ALIAS = '$ctrl';
export class FixIntentProcessor {
    static $inject = ['$document', 'SidebarContentService', 'LoadingService'];
    constructor($document, SidebarContentService, LoadingService) {
        'ngInject';
        this.$document = $document;
        this.SidebarContentService = SidebarContentService;
        this.LoadingService = LoadingService;
    }
    async open({ message, trackingProperties, source }) {
        const sidenav = await this.SidebarContentService.showSidebar({
            controller: FixIntentController,
            controllerAs: CONTROLLER_ALIAS,
            template: FixIntentView,
            appendToElement: this.$document[0].getElementById(ANALYSIS_DETAILS_ID),
            inputs: {
                selectedAnalyses: message.content.selectedAnalyses,
                intents: message.content.intents,
                LoadingService: this.LoadingService,
            },
        });
        const response = await sidenav.closeDeferred.promise;
        source.postMessage({
            response,
            trackingProperties,
        }, '*');
    }
}
FixIntentProcessor.$inject = ['$document', 'SidebarContentService', 'LoadingService'];
